import AdminLogsContainer from './adminLogs'

export default AdminLogsContainer